(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initSlider(root) {
    if (root.dataset.bvSliderInit) return;
    root.dataset.bvSliderInit = '1';
    var track = root.querySelector('[data-bv-track]');
    if (!track) return;
    var cards = track.children;
    var dots = root.querySelectorAll('[data-bv-dot]');
    var prev = root.querySelector('[data-bv-prev]');
    var next = root.querySelector('[data-bv-next]');

    function padLeft() { return parseFloat(getComputedStyle(track).paddingLeft) || 0; }
    function current() {
      var best = 0, bestDist = Infinity, left = track.scrollLeft;
      for (var i = 0; i < cards.length; i++) {
        var d = Math.abs(cards[i].offsetLeft - track.offsetLeft - padLeft() - left);
        if (d < bestDist) { bestDist = d; best = i; }
      }
      return best;
    }
    function go(i) {
      i = Math.max(0, Math.min(cards.length - 1, i));
      track.scrollTo({ left: cards[i].offsetLeft - track.offsetLeft - padLeft(), behavior: reduce ? 'auto' : 'smooth' });
    }
    function update() {
      var atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
      var c = atEnd ? cards.length - 1 : current();
      dots.forEach(function (d, i) { d.setAttribute('aria-current', i === c ? 'true' : 'false'); });
      if (prev) prev.disabled = track.scrollLeft <= 4;
      if (next) next.disabled = atEnd;
    }
    dots.forEach(function (d, i) { d.addEventListener('click', function () { go(i); }); });
    if (prev) prev.addEventListener('click', function () { go(current() - 1); });
    if (next) next.addEventListener('click', function () { go(current() + 1); });
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); go(current() + 1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(current() - 1); }
    });
    track.addEventListener('scroll', function () { window.requestAnimationFrame(update); }, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  function initAll() { document.querySelectorAll('[data-bv-slider]').forEach(initSlider); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
